const Url = "https://afacard.afa.pt:8000"; //http://172.16.2.76:8000 //http://172.17.1.38:8001
var user = JSON.parse(localStorage.getItem("user"));

function setUser(newUser) {
  user = newUser;
  localStorage.setItem("user", JSON.stringify(newUser));
}

function getUser() {
  return user;
}

export { Url, setUser, getUser };